import React from 'react';
import { Modal } from 'react-bootstrap';

function CustomModal({
  isOpen, onClose,
  children, title,
}) {
  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '0 1.5rem 1.5rem 1.5rem' }}>{children}</Modal.Body>
    </Modal>
  );
}

export default CustomModal;
